/* eslint-disable */
function expand_menu_children() {
  $(".main-menu-container li.menu-item-has-children .extract").on(
    "click",
    function() {
      var parent = $(this).closest('li.menu-item-has-children');
      parent.toggleClass('expanded');
      parent.children('.sub-menu').slideToggle( "fast", function() {
        // Animation complete.
      });
    }
  );
}

$('#mobilemenu-overlay').on('click', function() {
  $('#menu-btn').prop("checked", !$('#menu-btn').prop("checked"));
  $('#mobilemenu-overlay').hide();
  $('.header').removeClass('--active');
});

function add_item_span() {
  $(".main-menu-container li.menu-item-has-children").each(function() {
    $('<span class="extract" aria-label="toggle-menu"></span>').insertAfter($(this).find('> a'));
  });
}

$('.header-bottom-menu-container .menu-item-has-children').on('mouseover', function() {
  // Check if is mobile
  if($(window).width() < 1214) {
    return;
  }
  $(this).find('.sub-menu').show();
});

$("#menu-btn").on('change', function() {
  if(this.checked) {
    $('#mobilemenu-overlay').show();
    $('.main-nav').attr('aria-expanded', 'true');
    $('.header').addClass('--active');
  }
  else {
    $('#mobilemenu-overlay').hide();
    $('.main-nav').attr('aria-expanded', 'false');
    $('.header').removeClass('--active');
  }
});

add_item_span();
expand_menu_children();

//sticky header/banner
// var screenwidth = "";
// var resizeTimer;

// $(window).on('load', function() {
//   screenwidth = $(window).width();    
//   console.log(screenwidth);
  
//   //shrinkLogo( screenwidth );
// });

// $(window).on('resize', function(e) {
//   clearTimeout(resizeTimer);
//   resizeTimer = setTimeout(function() {
//     screenwidth = $(window).width();    
//     console.log(screenwidth);
    
//     //shrinkLogo( screenwidth );
//   }, 250);
// });

function shrinkLogo( screenwidth ) {
  if( screenwidth < 1600 ) {
    $('.header .site-logo .site-logo-text').addClass('--shrink');
  }
  else {
    $('.header .site-logo .site-logo-text').removeClass('--shrink');
  }
}

var prevposition =  $(window).scrollTop();
$(".header").css('top', '56px');

$(window).on('scroll', function() {
  let current = $(window).scrollTop(); 
  // let windowWidth = $(window).width();

  // if( windowWidth > 1214 ) {
    if(current == 0) {
      $(".header").removeClass("--scrolled");
      $(".header").css('top', '56px');
    }
    else if (current >= 1 && current <= 50) {
      // Ensure the value is always between 0 and 56 to prevent gap issues
      let newPos = Math.max(0, Math.min(56 - current, 56));
      $('.header').css('top', newPos + 'px');
    }
    else if(current >= 57) {
      $(".header").addClass("--scrolled");
      $('.header').css('top', '0px');
    } 
  // }
});


$('.dropdown-toggle-mobile').on('click', function() {
  $('.mobile-languages').toggleClass('active');
  var expanded = $(this).attr('aria-expanded') === 'true';
  $(this).attr('aria-expanded', (!expanded).toString());
});


/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/autoload/menus.js